export default "__VITE_ASSET__ueUrH5RX__"